class LightGalleryCustom {
    constructor() {
        // add global class identifier
        this.class = {
            lightGallery: '.lightgallery',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * initialize functions
     */
    init() {
        const galleries = document.querySelectorAll(this.class.lightGallery);

        if (galleries.length > 0) {
            galleries.forEach((gallery) => {
                const thumb = gallery.hasAttribute('data-enable-thumbs');
                const imgDownload = gallery.hasAttribute('data-enable-download');
                const countImg = gallery.querySelectorAll('.lightbox-item').length;
                const enableDrag = countImg > 1;

                const termsOfUseMarkup = document.querySelector('.js-lightgallery-termsofuse');

                lightGallery(gallery, {
                    licenseKey: 'D6DCCE11-A9E44E57-A60D181A-DB8E015BD6DCCE11-A9E44E57-A60D181A-DB8E015B',
                    plugins: [lgThumbnail],
                    controls: true,
                    selector: 'a.lightbox-item',
                    thumbnail: thumb,
                    exThumbImage: 'data-external-thumb-image',
                    alignThumbnails: 'left',
                    download: imgDownload,
                    hideBarsDelay: 999999,
                    counter: false,
                    preload: 0,
                    closable: true,
                    enableDrag,
                    allowMediaOverlap: true,
                    toggleThumb: true,
                });

                gallery.addEventListener('lgBeforeOpen', () => {
                    const toolbar = document.querySelector('.lg-toolbar');
                    const toggleThumb = document.querySelector('.lg-toggle-thumb');
                    const components = document.querySelector('.lg-components');

                    // adds terms of use inside toolbar
                    toolbar.appendChild(termsOfUseMarkup);
                    toolbar.querySelector('.js-lightgallery-termsofuse').classList.remove('d-none');

                    // move toggle thumb button
                    components.appendChild(toggleThumb);
                });

                gallery.addEventListener('lgBeforeSlide', (event) => {
                    const { index } = event.detail;
                    const download = document.querySelector('.lg-download');
                    const lightboxItem = document.querySelectorAll('.lightbox-item')[index];
                    const filesize = document.querySelector('.lg-filesize');

                    // adds download label and size
                    if (!document.querySelector('.lg-download-wrapper')) {
                        const wrapper = document.createElement('div');
                        wrapper.classList.add('lg-download-wrapper');
                        download.parentNode.insertBefore(wrapper, download);
                        wrapper.appendChild(download);
                    }

                    // create new filesize markup if not exist, otherwise overwrite filesize
                    if (!filesize) {
                        download.insertAdjacentHTML('beforeend', `<div class="d-none d-sm-inline-block lb-dl-font">${lightboxItem.dataset.downloadlabel}<span class="lg-filesize ms-1">(${lightboxItem.dataset.filesize})</span></div>`);
                    } else {
                        filesize.innerHTML = `(${lightboxItem.dataset.filesize})`;
                    }
                });
            });
        }
    }
}

export default new LightGalleryCustom();
